// Dependencies
import styled from 'styled-components';

const StepsStyles = styled.section`
  text-align: center;

  .heading {
    font-weight: var(--font-weight-light);
  }

  .subheading {
    font-weight: var(--font-weight-light);
    color: var(--color-bark);
  }

  .steps {
    margin: 3rem 0 0;
    text-align: left;
    counter-reset: step;

    li {
      padding: 3.125rem 0 2rem;

      .inner {
        display: flex;
        max-width: 58.75rem;
        margin: 0 auto;

        .icon-wrap {
          width: 5rem;

          .icon {
            width: 2.25rem;
            max-height: 2.375rem;
          }
        }

        .content-wrap {
          width: calc(100% - 5rem);
        }

        .heading {
          color: var(--color-bark);
          &::before {
            counter-increment: step;
            content: counter(step, upper-roman) '. ';
          }
        }
      }

      &:first-child {
        background-color: rgba(238, 235, 234, 0.4);
      }

      &:nth-child(2) {
        background-color: rgba(238, 235, 234, 0.6);
      }

      &:nth-child(3) {
        background-color: rgba(238, 235, 234, 0.8);
      }

      &:nth-child(4) {
        background-color: rgba(225, 221, 219, 0.6);
      }

      &:nth-child(5) {
        background-color: rgba(225, 221, 219, 0.8);
      }
    }
  }

  @media (min-width: 768px) {
    .steps {
      margin: 4rem 0 0;
      text-align: center;

      li {
        padding: 3.75rem 0 4.375rem;

        .inner {
          flex-wrap: wrap;

          .icon-wrap {
            margin: 0 0 1rem;
            width: 100%;
          }

          .content-wrap {
            width: 100%;
          }
        }
      }
    }
  }
`;

export default StepsStyles;
